import { render, staticRenderFns } from "./DocumentHeading.vue?vue&type=template&id=c1c8a040"
import script from "./DocumentHeading.vue?vue&type=script&lang=js"
export * from "./DocumentHeading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports